
export default function ExampleProductItem({item, theme}) {
    return (
        <div className='exampleProduct' dir='rtl' style={{backgroundColor:theme.primary_color}}>
            <div className='exampleProduct_img'></div>
            <p style={{margin:"0", color:theme.accent_color}}>{item.name}</p>
            <p style={{margin:"0", color:theme.accent_color}}>{item.hasDis ? 
                <span>מחיר: <b>{(item.price*item.disValue).toFixed(2)}</b>₪ <span style={{textDecoration:"line-through",color:"grey"}}>{item.price.toFixed(2)}₪</span></span> :
                `מחיר: ${item.price.toFixed(2)}₪`
            }</p>
            {item.hasDis && <div className='exampleProduct_onsale' style={{backgroundColor:`${theme.accent_color}`, color:`${theme.primary_color}`}}>במבצע!</div>}
        </div>
    )
}
